import { PostMessageData, ButtonCallback } from "../../types";

const getSendMessageButtonData = (
  content: ButtonCallback,
  traceId: string,
  strId: number | null
): PostMessageData =>
  strId
    ? {
        type: "button",
        content,
        traceId,
        replyMessageId: Number(strId),
      }
    : {
        type: "button",
        traceId,
        content,
      };

export { getSendMessageButtonData };
